var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.debugging)?_c('div',[(_vm.hidden)?_c('div',{staticStyle:{"color":"orange"},on:{"click":function($event){_vm.hidden = !_vm.hidden}}},[_c('icon-default',{staticStyle:{"cursor":"pointer"},attrs:{"icon":"info"}})],1):_c('pre',{on:{"click":function($event){_vm.hidden = !_vm.hidden}}},[_vm._v("     "+_vm._s(_vm.infoString)+"\n  ")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }